import vMenu from '@/common/sideBar/index.vue' //侧边栏
import {
    dataSource
} from "@/api/api.js";
import {
    checkout
} from '@/assets/js/checkout'
import { debounce } from '@/assets/js/util';
export default {
    name: 'home',
    components: { //注册组件
        vMenu, //侧边栏
        // IssueApplication
    },
    data() {
        return {
            baseForm: {
                area: [], //对接区域
                dockName1: "", //联系人1姓名
                dockName2: "", //联系人2姓名
                dockPhone1: "", //联系人1电话
                dockPhone2: "", //联系人1电话
                financeAmount: null, //贷款金额
                financeTerm: null, //贷款期限
                fundUse: "", //资金用途
                guaranteeType: [], //担保方式
                isShow: "",
                remarks: "", //备注
                entFinanceId:null,
                products:[]
                //status: ""
            },
            guaranteeList: [],
            regionList: [],
            productId: '',
            editProduct: {}, //编辑的缓存数据
            formCheck:[//信息校验
                {
                    id: '1',
                    name: '贷款金额',
                    type: 'parseFloat',
                    decimal:'4',
                    value: '',
                    required: true,
                    msg: '',
                    info: '融资额度为数字且保留小数点后四位',
                },
                {
                    id: '2',
                    name: '贷款期限',
                    type: 'number',
                    value: '',
                    required: true,
                    msg: '',
                    info: '请输入贷款期限',
                },
                {
                    id: '3',
                    name: '联系人姓名',
                    type: 'chinese',
                    value: '',
                    required: true,
                    msg: '',
                    info: '请输入联系人姓名',
                },
                {
                    id: '4',
                    name: '联系人电话',
                    type: 'phone',
                    value: '',
                    required: true,
                    msg: '',
                    info: '请输入联系人电话',
                },
                {
                    id: '5',
                    name: '紧急联系人姓名',
                    type: 'chinese',
                    value: '',
                    required: true,
                    msg: '',
                    info: '紧急联系人姓名',
                },
                {
                    id: '6',
                    name: '紧急联系人电话',
                    type: 'phone',
                    value: '',
                    required: true,
                    msg: '',
                    info: '紧急联系人电话',
                },
                {
                    id: '7',
                    name: '资金用途',
                    type: 'size',
                    value: '',
                    required: true,
                    msg: '',
                    info: '请输入资金用途',
                },
                {
                    id: '7',
                    name: '备注',
                    type: 'size',
                    value: '',
                    //required: true,
                    msg: '',
                    info: '请输入备注',
                },
            ],
        
        };
    },
    computed: {},
    filters: {},
    methods: {
        inputBlur(item){ //校验
            checkout.otherCheckout(item);
            if(item.msg){
                this.$message.error(item.msg)
                return false;
            }
        },
        
        postGetConditionListFn() { //申请管理列表-筛选条件列表
            dataSource.postGetConditionList().then(res => {
                if (res.data.success) {
                    let data = res.data.data;
                    data.area.map(item => { //对接区域
                        this.regionList.push({
                            value: item.itemCode,
                            name: item.itemName
                        })
                    })
                    data.guateeType.map(item => {
                        this.guaranteeList.push({ //担保方式
                            value: item.itemCode,
                            name: item.itemName
                        })
                    })
                } else {
                    this.$message.error(res.data.msg);
                }

            }).catch(err => {

            })
        },
        match() { //下一步智能匹配
            this.baseForm.financeAmount = this.formCheck[0].value;
            this.baseForm.financeTerm = this.formCheck[1].value;
            this.baseForm.dockName1 = this.formCheck[2].value;
            this.baseForm.dockPhone1 = this.formCheck[3].value;
            this.baseForm.dockName2 = this.formCheck[4].value;
            this.baseForm.dockPhone2 = this.formCheck[5].value;
            this.baseForm.fundUse = this.formCheck[6].value;
            this.baseForm.remarks = this.formCheck[7].value;
           
            if (this.baseForm.financeAmount == null || this.baseForm.financeAmount=='') {
                this.$message.error('请输入贷款金额');
                return;
            }
            if (this.baseForm.financeTerm == null || this.baseForm.financeTerm=='') {
                this.$message.error('请输入贷款期限');
                return;
            }
            if (this.baseForm.guaranteeType.length == 0) {
                this.$message.error('请输入担保方式');
                return;
            }
            if (this.baseForm.area.length == 0) {
                this.$message.error('请输入对接区域');
                return;
            }
            if (this.baseForm.dockName1.length == 0) {
                this.$message.error('请输入融资对接人1姓名');
                return;
            }
            if (this.baseForm.dockPhone1.length == 0) {
                this.$message.error('请输入融资对接人1手机号');
                return;
            }
            if (this.baseForm.dockName2.length == 0) {
                this.$message.error('请输入融资对接人2姓名');
                return;
            }
            if (this.baseForm.dockPhone2.length == 0) {
                this.$message.error('请输入融资对接人2手机号');
                return;
            }
            
            if (this.baseForm.fundUse.length == 0) {
                this.$message.error('请输入资金用途');
                return;
            }
            let area = this.baseForm.area.length ? this.baseForm.area.join() : "";
            let guaranteeType = this.baseForm.guaranteeType.length ? this.baseForm.guaranteeType.join() : "";
            // this.baseForm.id = sessionStorage.getItem("productId").length ? sessionStorage.getItem("productId") : 0;
                
            this.baseForm.entFinanceId = null;
            this.baseForm.guaranteeType = guaranteeType;
            this.baseForm.area = area;
            sessionStorage.setItem('addProductInfo',JSON.stringify(this.baseForm));
            this.$router.push({
                name: 'intelligentMatching'
            })
            // dataSource.postCompanyProductAdd(this.baseForm).then(res => {
            //     if (res.data.success) {
            //         let data = res.data.data;
            //         let pId = data.id;
            //         sessionStorage.setItem("pId", pId)
            //         let data1 = {
            //             productId: pId,
            //             state: "编辑",
            //         }
            //         sessionStorage.setItem('editProduct', JSON.stringify(data1));
            //         this.$router.push({
            //             name: 'intelligentMatching'
            //         })
            //     } else {
            //         this.$message.error(res.data.msg);
            //     }

            // }).catch(err => {

            // })
            

        },
        postDemandSaveFn() {//发布融资需求 暂存
            let area = this.baseForm.area.length ? this.baseForm.area.join() : "";
            let guaranteeType = this.baseForm.guaranteeType.length ? this.baseForm.guaranteeType.join() : "";
            
            this.baseForm.entFinanceId = "";
            this.baseForm.guaranteeType = guaranteeType;
            this.baseForm.area = area;
            this.baseForm.financeAmount = this.formCheck[0].value;
            this.baseForm.financeTerm = this.formCheck[1].value;
            this.baseForm.dockName1 = this.formCheck[2].value;
            this.baseForm.dockPhone1 = this.formCheck[3].value;
            this.baseForm.dockName2 = this.formCheck[4].value;
            this.baseForm.dockPhone2 = this.formCheck[5].value;
            this.baseForm.fundUse = this.formCheck[6].value;
            this.baseForm.remarks = this.formCheck[7].value;
            dataSource.postDemandSave(this.baseForm).then(res => {
                
                if (res.data.success) {
                    this.$message({
                        message:"暂存成功！",
                        type: 'success',
                        duration: 5000,
                    });
                    this.$router.push({
                        name:'applyManage'
                    })
                } else {
                    this.$message.error(res.data.msg)
                }


            }).catch(err => {

            })
        },
        cancle(){//取消
            this.$router.push({
                name:'applyManage'
            })
        },
    },
    created() {
        this.debouncePostDemandSaveFn = debounce(this.postDemandSaveFn, 500, true)
        this.postGetConditionListFn();
        
    },
    mounted() {},
    activated() {}
}